const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalHealthLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1080 1080",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M713.281,70.216l-402.672,0c-36.816,0 -67.112,30.296 -67.112,67.112l0,805.344c0,36.816 30.296,67.112 67.112,67.112l402.672,-0c36.817,-0 67.112,-30.296 67.112,-67.112l0,-805.344c0,-36.816 -30.295,-67.112 -67.112,-67.112Zm-402.672,-67.112c-73.633,0 -134.224,60.591 -134.224,134.224l0,805.344c0,73.633 60.591,134.224 134.224,134.224l402.672,-0c73.633,-0 134.224,-60.591 134.224,-134.224l0,-805.344c0,-73.633 -60.591,-134.224 -134.224,-134.224l-402.672,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.945,982.488c20.644,0 37.632,-16.987 37.632,-37.631c-0,-20.645 -16.988,-37.632 -37.632,-37.632c-20.644,-0 -37.631,16.987 -37.631,37.632c-0,20.644 16.987,37.631 37.631,37.631Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M853.939,269.315l-0,72.509c-0,5.253 -4.265,9.518 -9.519,9.518l-19.036,-0c-5.254,-0 -9.519,-4.265 -9.519,-9.518l0,-72.509c0,-5.253 4.265,-9.518 9.519,-9.518l19.036,-0c5.254,-0 9.519,4.265 9.519,9.518Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.872,223.542l-0,72.509c-0,5.253 -4.265,9.518 -9.519,9.518l-19.036,0c-5.254,0 -9.519,-4.265 -9.519,-9.518l0,-72.509c0,-5.253 4.265,-9.518 9.519,-9.518l19.036,-0c5.254,-0 9.519,4.265 9.519,9.518Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.872,323.901l-0,72.509c-0,5.253 -4.265,9.518 -9.519,9.518l-19.036,0c-5.254,0 -9.519,-4.265 -9.519,-9.518l0,-72.509c0,-5.253 4.265,-9.518 9.519,-9.518l19.036,0c5.254,0 9.519,4.265 9.519,9.518Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.704,393.844l-57.538,-56.386l-13.552,-81.302c-1.898,-14.169 -14.047,-25.111 -28.731,-25.111c-13.454,0 -24.78,9.186 -28.043,21.623l-1.623,4.745c-18.297,-39.44 -11.074,-87.821 21.667,-120.201c42.349,-41.33 111.908,-41.33 154.256,0l22.513,22.034l22.513,-22.034c42.348,-41.33 111.908,-41.33 154.256,0c42.008,41.544 42.008,109.428 -0,150.972l-145.061,142.155l-24.988,-88.864c-2.512,-13.393 -14.278,-23.542 -28.396,-23.542c-13.321,0 -24.549,9.036 -27.884,21.307l-19.389,54.604Zm-95.935,-94.014l-11.885,-11.646c-0.134,-0.133 -0.268,-0.266 -0.401,-0.399c2.659,0.805 5.479,1.238 8.4,1.238c1.302,-0 2.584,-0.087 3.841,-0.253c0.028,3.553 0.041,7.426 0.045,11.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.498,443.383l88.931,-0l62.483,-183.586l57.021,341.468l90.088,-254.468l48.02,172.055l45.717,-75.469l50.615,-0l130.743,0.274",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "35.83px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.498,672.918l-0,23.244c-0,6.414 5.207,11.622 11.622,11.622l294.383,-0c6.414,-0 11.622,-5.208 11.622,-11.622l0,-23.244c0,-6.415 -5.208,-11.622 -11.622,-11.622l-294.383,-0c-6.415,-0 -11.622,5.207 -11.622,11.622Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.498,731.971l-0,23.244c-0,6.415 5.207,11.622 11.622,11.622l424.822,0c6.414,0 11.622,-5.207 11.622,-11.622l-0,-23.244c-0,-6.414 -5.208,-11.622 -11.622,-11.622l-424.822,0c-6.415,0 -11.622,5.208 -11.622,11.622Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.498,791.932l-0,23.244c-0,6.414 5.207,11.622 11.622,11.622l347.293,-0c6.415,-0 11.622,-5.208 11.622,-11.622l0,-23.244c0,-6.415 -5.207,-11.622 -11.622,-11.622l-347.293,-0c-6.415,-0 -11.622,5.207 -11.622,11.622Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.498,851.561l-0,23.244c-0,6.415 5.207,11.622 11.622,11.622l216.991,0c6.414,0 11.622,-5.207 11.622,-11.622l-0,-23.244c-0,-6.414 -5.208,-11.622 -11.622,-11.622l-216.991,0c-6.415,0 -11.622,5.208 -11.622,11.622Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalHealthLogo);
export default __webpack_public_path__ + "static/media/digital-health-logo.b9aae85c4b90fae25cb9e3f648bbc499.svg";
export { ForwardRef as ReactComponent };